var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-card"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))]),_c('div',{staticClass:"chart"},[_vm._t("default")],2),_c('div',{staticClass:"line"}),_c('div',{staticClass:"footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }